export default __webpack_public_path__ + "static/media/dashboard-6.fbc87c1c.png";